import { Typography } from '@mui/material'
import React from 'react'

export const MovingText = ({ text ,variant,color,width }) => {
    return (
        <Typography
            variant={variant || "body1"}
            sx={{
                display: "inline-block", // Keeps text in one line
                whiteSpace: "nowrap", // Prevents line breaks
                overflow: "hidden", // Hides overflowing text
                textOverflow: "ellipsis", // Adds "..." when text overflows
                width:width || "90%",
                position: "relative", // Helps with absolute animation
                color:color || "inherit",

                "&:hover span": {
                    animation: "scrollText 5s linear infinite", // Triggers animation on hover
                },

                "@keyframes scrollText": {
                    "0%": { transform: "translateX(0%)" },
                    "100%": { transform: "translateX(-100%)" }, // Moves text left continuously
                }
            }}
        >
            <span style={{ display: "inline-block" }}>
                {text}
            </span>
        </Typography>
    )
}
